import React, { Component, Fragment } from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { OHIO_CASH_RECEIPTS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { TitledCard } from 'Components/';
import { OhioCashReceiptsReportFieldEnum as Fields } from 'Common/FieldEnum';
import { mealTypeOptions } from '../helpers/constants';
import { DatePickerField, InputField } from 'Common/SemanticWrapper';
import { MONTH_YEAR_DATE_FORMAT } from 'Common/Constants';
import SelectSitesTable from 'Common/SelectSitesTableReduxForm';

class OhioCashReceiptsReportFormContainer extends Component {
  render() {
    return (
      <Fragment>
        <Form name={OHIO_CASH_RECEIPTS_REPORT_FORM_NAME}>
          <TitledCard title={''}>
            <Grid>
              <Grid.Row>
                <Grid.Column className="input-group--btn-group">
                  <ReduxFormButtonGroup
                    label={'Meal Type'}
                    formName={OHIO_CASH_RECEIPTS_REPORT_FORM_NAME}
                    options={mealTypeOptions}
                    fieldName={Fields.MealType}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={6}>
                  <Field
                    label={'County'}
                    name={Fields.County}
                    component={InputField}
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column>
                  <Field
                    name={Fields.Date}
                    component={DatePickerField}
                    dateFormat={MONTH_YEAR_DATE_FORMAT}
                    maxDate={moment()}
                    label="Date"
                  />
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column className="field">
                  <label className={'p-b-0'}>Sites</label>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Field name={Fields.SiteIds} component={SelectSitesTable} />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
        </Form>
      </Fragment>
    );
  }
}

const validate = values => {
  let errors = {};

  if (!values[Fields.MealType]) {
    errors[Fields.MealType] = 'Meal Type must be selected.';
  }

  if (!values[Fields.SiteIds] || !values[Fields.SiteIds].length) {
    errors[Fields.SiteIds] = 'At least one site must be selected.';
  }

  if (!moment(values[Fields.Date], MONTH_YEAR_DATE_FORMAT).isValid()) {
    errors[Fields.Date] = 'A valid date must be selected.';
  }

  return errors;
};

export default reduxForm({
  form: OHIO_CASH_RECEIPTS_REPORT_FORM_NAME,
  validate,
  enableReinitialize: true,
})(withRouter(OhioCashReceiptsReportFormContainer));



// WEBPACK FOOTER //
// ./src/pages/ohiocashreceiptsreport/components/OhioCashReceiptsReportForm.js